import m from "./../../../dist/es2015/themes/Material.js";
export const am5themes_Material = m;